<template>
  <div class="net-income-card">
    <el-card class="box-card" style="margin-bottom: 30px;">
      <div slot="header" class="row d-flex align-items-center">
        <b-col cols="6">
          <h3 class="mb-0">Net Income</h3>
        </b-col>
        <b-col>
          <el-button @click="$refs.drawer_net_income.viewDetails()" class="float-right py-0 text-primary" type="text">View
            Details</el-button>
        </b-col>
      </div>
      <div v-if="activeCustomer">
        <div class="mb-2">
          <span class="text-primary total-net-income" v-if="activeCustomer">RM {{
            parseFloat(_gHlp.getValue(activeCustomer,'incomes.main.net_income',0)).toLocaleString(undefined, { minimumFractionDigits: 2 })
          }}</span>
        </div>
        <div v-if="activeCustomer.incomes && activeCustomer.incomes.variable && activeCustomer.incomes.variable.length > 0"
          class="d-flex align-items-center">
          <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
          <span>Variable Income</span>
        </div>
      </div>
    </el-card>
    <DrawerNetIncome ref="drawer_net_income" />
  </div>
</template>
<script>
import { Card, Button } from 'element-ui';
import DrawerNetIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/DrawerNetIncome';
// import DrawerViewNetIncomeDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/DrawerNetIncome'
import { mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';

export default {
  name: 'net-income',
  components: {
    DrawerNetIncome,
    [Card.name]: Card,
    [Button.name]: Button,
    DrawerNetIncome
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer'])
  }
}
</script>